import { clients } from '@oncolens/oncolens-ui/lib/api/client';
import { UseQueryOptions, useQuery } from 'react-query';
import { SsoConnectionDto } from '../types/index';
import { SsoConnectionKeys } from './ssoConnection.keys';

export const getSsoConnection = async (orgId: string) => {
  const response = await clients.admin.get<SsoConnectionDto>(`/ssointegrations/byOrgId/${orgId}`);
  return response.data;
};

export const useGetSsoConnection = (
  orgId: string | undefined,
  options?: UseQueryOptions<SsoConnectionDto>,
) => {
  const definiteOrganizationId = orgId?.toString() ?? '';
  return useQuery(
    SsoConnectionKeys.detail(definiteOrganizationId),
    () => getSsoConnection(definiteOrganizationId),
    {
      enabled: orgId !== undefined,
      ...options,
    },
  );
};
